<template>
    <div class="headerBox">
        <div class="header" :style="headStyle">
            <div class="top">
                <div class="left">
                    <router-link to="/" class="logo">
                        <img src="@/assets/images/logo.png" alt=""/>
                    </router-link>
                    <div class="nav">
                        <router-link v-for="(value,index) in $t('header.menus')" :key="index" :to="{ name:value.path }" :class="{'nava':true,'active':index==0}">
                            {{value.name}}
                        </router-link>
                    </div>
                </div>
                <div class="right">
                    <!--<div class="lan">-->
                      <!--<span class="text pr6" @click="changeLang('zh')" :class="lang == 'zh' ? 'check' : ''">中</span>-->
                      <!--<span>/</span>-->
                      <!--<span class="text pl6" @click="changeLang('en')" :class="lang == 'en' ? 'check' : ''">EN</span>-->
                    <!--</div>-->
                    <div @click="goLogin()" class="login">
                        <button>{{$t('loginText')}}</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    // import Nav from "./nav.vue";
    import cookieBus from '../../server/cookieBus.js';
    import cookie from "js-cookie";

    export default {
        name: "Header",
        props: ["title"],
        inject: ["reload"],
        components: {
            // Nav
        },
        head() {
            return {
                "title": this.$t('metaInfoData.title'),
                "keywords": this.$t(`metaInfoData.${this.title}.keywords`),
                "description": this.$t(`metaInfoData.${this.title}.description`)
            }
        },
        data() {
            return {
                navFlag: false,
                headStyle: "background: rgba(5, 100, 205, 0)",
                lang: this.$i18n.locale
            };
        },
        mounted() {
            if (typeof window != undefined) {
                const {WOW} = require("wowjs");
                require('animate.css')
                new WOW().init();
                this.handleScroll()
                this.$emit('test')
                // document.getElementById("animProject").style="visibility: visible;"
                // document.getElementById("animProject").classname="project wow slideInUp animated"
            }
            this.$nextTick(()=>{
                this.$emit('test')
            })
            // 监听（绑定）滚轮 滚动事件
            window.addEventListener("beforeunload", this.fn);
            window.addEventListener("scroll", this.handleScroll, true);
        },
        methods: {
            outStyle: function (type) {
                if (type == "over") {
                    this.navFlag = true;
                } else {
                    this.navFlag = false;
                }
            },
            handleScroll: function () {
                // 页面滚动距顶部距离
                const scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;
                if (scrollTop > 200) {
                    this.headStyle = "background:#1C242D";
                } else {
                    this.headStyle = "";
                }
            },
            // 让页面回到顶部
            fn: function () {
                window.scrollTo(0, 0);
            },
            // 中英文切换
            changeLang(type) {
                if (type == "en") {
                    this.$i18n.locale = "en";
                    this.lang = "en";
                    cookie.set("lang", "en");
                } else if (type == "zh") {
                    this.$i18n.locale = "zh";
                    this.lang = "zh";
                    cookie.set("lang", "zh");
                }
                this.$nextTick(() => {
                    this.reload();
                    this.fn();
                    // window.location.reload();
                });
            },
            goLogin(){
                this.$router.push({path:"/login"})
            }
        },
        created() {
            if (this.title == "") {
                this.headStyle = "background: rgba(5, 100, 205, 1)";
            }
        },
        beforeCreate() {
            if (cookieBus.$cookie != undefined) {
                this.$i18n.locale = cookieBus.$cookie;
            } else if (cookie.get("language") != undefined) {
                if (cookie.get("lang") != undefined) {
                    this.$i18n.locale = cookie.get("lang");
                } else {
                    this.$i18n.locale = cookie.get("language");
                }
            }
        },
    };
</script>
<style lang="scss">
    .nav{
        .router-link-exact-active{
            border-bottom: 4px solid rgba(0,161,255,1);
        }
    }
    .headerBox {
        width: 100%;
        min-width: 1300px;
        position: fixed;
        z-index: 100;
        overflow: hidden;
        /* overflow-x: scroll; */
        /* background-color: aqua; */
        .header {
            /* width: ; */
            min-width: 1300px;
            height: 98px;
            background: rgba(5, 100, 205, 0);
            font-size: 16px;
          
            top: 0;
            .top {
                width: 1300px;
                margin: auto;
                height: 52px;
                padding: 22px 0 24px 0;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .left,.right{
                    display: flex;
                    flex-direction: row;
                }
                .right{
                    .login{
                        padding-left:20px ;
                        button{
                            outline: none;
                            margin-top: 5px;
                            width:112px;
                            height:40px;
                            border:2px solid rgba(255,255,255,1);
                            background: transparent;
                            color: #fff;
                            &:hover{
                                border:3px solid rgba(255,255,255,1);
                                cursor:pointer;
                            }
                        }
                    }
                }
                .logo {
                    float: left;

                    img {
                        width:98px;
                        height:54px;
                    }
                }

                .nav {
                    float: left;
                    margin-left: 51px;
                    line-height: 52px;
                    cursor: pointer;

                    a {
                        text-decoration: none;
                        font-weight: 600;
                    }

                    &:hover {
                        /*.nava,*/
                        /*.nava1 {*/
                            /*color: rgba(255, 255, 255, 0.5);*/
                        /*}*/
                        .nava{
                            border-bottom: none;
                        }
                        .nava:after{
                            width:32px;
                            height:4px;
                            background:rgba(0,161,255,1);
                        }
                    }

                    .nava {
                        margin-right: 40px;
                        height: 52px;
                        display: inline-block;
                        color: rgba(255, 255, 255, 1);
                        /* border-bottom:none; */
                        &:hover {
                            color: rgba(255, 255, 255, 1);
                            border-bottom: 4px solid rgba(0,161,255,1);
                        }
                    }

                    .nava1 {
                        display: inline-block;
                        position: relative;
                        margin-right: 55px;
                        font-weight: 600;
                        color: rgba(255, 255, 255, 1);

                        &:hover {
                            color: rgba(255, 255, 255, 1);
                        }
                    }
                }

                .lan {
                    /*width: 10%;*/
                    float: right;
                    line-height: 52px;
                    text-align: right;
                    color: rgba(255, 255, 255, 0.5);
                    cursor: pointer;
                    display: flex;
                    flex-direction: row;
                    &:hover {
                        .text {
                            color: rgba(255, 255, 255, 0.5);
                        }
                    }

                    .text:hover {
                        color: rgba(255, 255, 255, 1);
                    }

                    .check {
                        color: rgba(255, 255, 255, 1);
                    }
                }
            }
        }
    }
</style>